import { replacerCostIfValue } from 'utils/replacerCost';
import { getEditableNumberCell } from 'utils/tableCells';

import { useMemo } from 'react';
import type { Control } from 'react-hook-form';

export interface IUseSeasonsInflationColumns {
    isEditable?: boolean;
    control?: Control;
}

export const useSeasonsInflationColumns = (props: IUseSeasonsInflationColumns) => {
    const { isEditable, control } = props;

    return useMemo(
        () => [
            {
                title: 'Сезон',
                accessor: 'year',
                width: 337,
            },
            getEditableNumberCell({
                title: 'Коэффициент инфляции',
                accessor: 'inflationRate',
                isEditable,
                control,
                doNotCheckRowFlag: true,
                collectionEditAccessor: ['seasonsInflation', '0', 'inflationRate'],
                width: 337,
                textFieldWidth: 'full',
                decimalScale: 3,
                rules: {
                    validate: (value: any) => !!replacerCostIfValue(value),
                },
            }),
        ],
        [control, isEditable],
    );
};
